import { localeOrder, siteConfig, siteContent } from '../../content/siteContent.js'
import { getLocalizedPath } from '../../lib/routing.js'
import { KineticMarquee } from '../fx/KineticMarquee.jsx'
import { StatusTicker } from '../fx/StatusTicker.jsx'

export function Footer({ locale, reducedMotion }) {
  const copy = siteContent[locale]

  return (
    <footer className="site-footer">
      <KineticMarquee compact reducedMotion={reducedMotion} />
      <div className="site-footer__grid">
        <div>
          <strong>{siteConfig.legalName}</strong>
          <p>Reg. {siteConfig.registrationNumber}</p>
          <a href={`mailto:${siteConfig.contactEmail}`}>{siteConfig.contactEmail}</a>
        </div>
        <nav aria-label="Footer">
          <a href={getLocalizedPath(locale, 'privacy')}>{copy.footer.privacy}</a>
          <a href={getLocalizedPath(locale, 'terms')}>{copy.footer.terms}</a>
          {localeOrder.map((targetLocale) => (
            <a key={targetLocale} href={getLocalizedPath(targetLocale, 'home')}>
              {siteContent[targetLocale].label}
            </a>
          ))}
        </nav>
      </div>
      <StatusTicker location="footer" reducedMotion={reducedMotion} />
    </footer>
  )
}
